// import 'zone.js';
// import "@angular/compiler";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "environments/environment";
import { AppPublicModule } from "@root/app-public.module";

if (environment.production) {
  enableProdMode();
  /** TODO: delete this */
  console.log = () => {};
}

/**
 * public是指无需登录态和鉴权系统即可正常访问的公共页面，比如分享页，保洁页等
 * 由于不需要这些额外的逻辑，所以单独抽离出一个初始化模块
 */
const isPublic = () => {
  return ["/app/h5", "/app/share"].some((path) => location.pathname.startsWith(path));
  // return location.pathname?.startsWith("/app/h5");
};

platformBrowserDynamic()
  .bootstrapModule(isPublic() ? AppPublicModule : AppModule)
  .catch((err) => console.log(err));
